
function getSaveSearchState( type ) {
    var saveSearchButton = document.querySelector( `[data-save-property=${type}]` );

    if ( !saveSearchButton ) {
        return null;
    }

    var state = {
        saveValue: {},
        saveMeta: {},
    };

    var data = saveSearchButton.dataset;

    if ( data.saveValue ) {
        state.saveValue = JSON.parse( data.saveValue );
    }

    if ( data.saveMeta ) {
        state.saveMeta = JSON.parse( data.saveMeta );
    }

    return state;
}

export {
    getSaveSearchState,
};
